import React, { useEffect } from 'react';
import ComparingItem from './ComparingItem.js';
import TabularDataView from './TabularDataView.js';
import Loader from '../global/Loader.js';
import { COMPARE_PRODUCTS_HEADING, COMPARE_LINK } from '../../data/Localization';

export default function ComparingItemsView(props) {
	let tabularData = props.tabularData;
	useEffect(() => {
		var nav = document.querySelector('.mobile-nav');
		if (nav) {
			var overlay = document.querySelector('.mobile-overlay');
			var popup = document.querySelector('.mobile-nav-popup');

			var toggleState = function (elem, one, two) {
				var elem = document.querySelector(elem);
				elem.setAttribute('data-vertical-nav', elem.getAttribute('data-vertical-nav') === one ? two : one);
			};

			nav.onclick = function (e) {
				toggleState('.mobile-nav-popup', 'false', 'true');
				toggleState('.mobile-overlay', 'hidden', 'visible');

				e.preventDefault();
			};

			overlay.onclick = function (e) {
				toggleState('.mobile-nav-popup', 'false', 'true');
				toggleState('.mobile-overlay', 'hidden', 'visible');
				e.preventDefault();
			};

			popup.onclick = function (e) {
				toggleState('.mobile-nav-popup', 'false', 'true');
				toggleState('.mobile-overlay', 'hidden', 'visible');

				e.preventDefault();
			};

			let headerLinks = [].slice.call(document.querySelectorAll('.section-heading-wrapper'));
			headerLinks.forEach((cta) => {
				cta.addEventListener('click', (e) => {
					toggleState('.mobile-nav-popup', 'false', 'fixed');
					toggleState('.mobile-overlay', 'hidden', 'visible');
					e.preventDefault();
				});
			});
		}
	});

	let ComparaingOptions = props.compareItems.map((option, indx) => {
		if (option.isSelected) {
			return <ComparingItem key={indx} optionInfo={option} handleComparisonSelection={props.handleComparisonSelection} />;
		}
	});

	function handleCompareAction() {
		props.handleCompareAction();
	}

	if (tabularData == null) {
		return <Loader />;
	}

	return (
		<section id={props.comparisonTableId} className="comparison-table mobile-expanded leader-2">
			<div className="comparison-table__wrapper" aria-selected="true" aria-expanded="true">
				<div className="mobile-nav">
					<div className="mobile-nav-wrapper">
						<ul role="navigation" id="sections">
							<li className="nav-section current active">Sections</li>
						</ul>
						<div className="nav-mobile-arrow"></div>
					</div>
				</div>
				<div className="comparison-table__content grid-container">
					<div className="comparison-table__content-title">
						<h2 className="comparison-table__content--heading avenir-regular padding-trailer-0">{COMPARE_PRODUCTS_HEADING}</h2>
						<div className="comparison-table__content--cta">
							<calcite-button onClick={handleCompareAction} scale="l" color="neutral" kind="neutral">
								{COMPARE_LINK}
							</calcite-button>
						</div>
					</div>

					<div className="comparison-table__content-items">
						{ComparaingOptions}
						<div onClick={handleCompareAction} className="nav-arrow open-mobile-popup"></div>
					</div>
				</div>
			</div>
			<div className="mobile-nav-popup" data-vertical-nav="false">
				<ul>
					{tabularData &&
						tabularData.sections.map((section, indx) => {
							return (
								<li key={indx} className="nav-section active">
									<a href={`#${section}`} className="scroll">
										{section}
									</a>
								</li>
							);
						})}
				</ul>
				<div className="nav-mobile-arrow"></div>
			</div>
			<div className="mobile-overlay" data-vertical-nav="hidden"></div>

			{/* tabular data */}
			<TabularDataView lookUpByProductPath={props.lookUpByProductPath} compareItems={props.compareItems} tableData={props.tabularData} />
			{/* end of tabular data */}
		</section>
	);
}
